import { getPlatform } from "@derstandard/utils";

interface ShortcutParams {
	alt?: boolean;
	shift?: boolean;
	control?: boolean;
	code: string;
	callback?: () => void;
}

export function shortcut(node: HTMLElement, params: ShortcutParams | undefined) {
	let handler: ((e: KeyboardEvent) => void) | undefined;

	const isMacOS = getPlatform() === 'mac';

	function removeHandler() {
		window.removeEventListener('keydown', handler);
	}

	function setHandler() {
		removeHandler();
		if (!params) {
			return;
		}
		handler = (e: KeyboardEvent) => {
			const expectedAlt = isMacOS ? Boolean(params.alt) : true;
			const expectedControl = isMacOS ? Boolean(params.control) : false;

			if (expectedAlt !== e.altKey || Boolean(params.shift) !== e.shiftKey || expectedControl !== e.ctrlKey || params.code !== e.code) {
				return;
			}

			e.preventDefault();
			typeof params.callback === 'function' ? params.callback() : node.click();
		};

		window.addEventListener('keydown', handler);
	};

	setHandler();

	return {
		update: setHandler,
		destroy: removeHandler,
	};
};
